import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import BlockMaxWidthHandler from '@/shared/content/blocks/helpers/BlockMaxWidthHandler.vue';
import OutletProductDetail from '@/shared/product/details/ui/outlet/OutletProductDetail.vue';
import useOutletProductDetailData from '@/shared/product/details/ui/outlet/useOutletProductDetailData';
import { B2BOutletProductDetailTileModel } from '@/types/B2BcontentServerContract';
import { onUnmounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'B2BOutletProductDetailTile',
  props: {
    content: null
  },
  setup(__props: any) {

const props = __props as {
    content: B2BOutletProductDetailTileModel
}



const { setOutletProductData, clearOutletProductData } = useOutletProductDetailData();
setOutletProductData(props.content.productDetail);
onUnmounted(clearOutletProductData);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(BlockMaxWidthHandler, null, {
      default: _withCtx(() => [
        _createVNode(OutletProductDetail)
      ]),
      _: 1
    })
  ]))
}
}

})